const createTypenameTypeguard =
  <T extends string>(typename: T) =>
  <N extends { __typename?: string } | undefined | null>(
    node: N,
  ): node is Extract<N, { __typename: T }> => {
    return node !== undefined && node !== null && node.__typename === typename;
  };

export default createTypenameTypeguard;
